import { type ComponentCreation } from './types'

export const createMuiSkeleton = () =>
  ({
    MuiSkeleton: {
      variants: [
        {
          props: { variant: 'text' },
          style: { transform: 'scale(1, 0.8)', borderRadius: '1em' },
        },
      ],
    },
  }) satisfies ComponentCreation
